import axiosInstace from './../providers/Axios';

import { getTracking } from '../config/paths';

export const callGetTracking = async (order) => {
  return axiosInstace({
    url: `${getTracking}/${order}`,
    method: 'get',
  });
};
